.graphic-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.graphic {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 90%;
}

.graphic > svg {
    width: 100%;
}
